/** Cosmetic clocks only; safe to import in both the parent page and scene iframe. */
export const ATTACK_IMPACT_MS = 600;
export const THROW_FLIGHT_MS = 650;
export interface AttackThrowPresentation { inventoryId: string; arcing: boolean }
